import { useEffect } from "react";
import { useTrelloPowerUpContext } from "../../trello-iframe/context";
import { styles } from "../authorize";

interface IProps {
  appName: string;
}

export const _PreAuthorization = ({ appName }: IProps) => {
  const { trelloIFrame } = useTrelloPowerUpContext();

  useEffect(() => {
    trelloIFrame.sizeTo("#authorize-container");
  });

  const onClickHandler = () => {
    trelloIFrame
      .getRestApi()
      .authorize({ scope: "read,write,account" })
      .then(function () {
        // trackEvent("AuthorizationFinished", { success: true });
        return trelloIFrame.notifyParent("done");
      })
      // https://developer.atlassian.com/cloud/trello/power-ups/rest-api-client/#handling-cancellations
      .catch(() => {
        // trackEvent("AuthorizationFinished", { success: false, error: e });
        return trelloIFrame.notifyParent("done");
      });
  };

  return (
    <div css={styles.container} id="authorize-container">
      <p>Authorize {appName} Power Up to continue</p>
      <button type="button" className="mod-primary" onClick={onClickHandler}>
        Click to authorize
      </button>
    </div>
  );
};
